import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { format, parseISO } from 'date-fns';
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import * as am5 from "@amcharts/amcharts5";
import { useNavigate } from "react-router-dom";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import animation from '../../../../images/jm-animation.gif'
import info from '../../../../images/info.png'
import Button from "@mui/material/Button";

function RollingReturns(props) {
    const [data, setData] = useState([]);
    const [value, setValue] = useState("1year");
    const { BaseURL } = useContext(URLstateContext);
    let navigate = useNavigate();
    const [chartData, setchartData] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getSchemeCodeIn = props.getSchemeCode;
    let getSchemeTypeIn = props.getSchemeType;

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetRollingReturns", {
            IVSchemeCode: getSchemeCodeIn,
            IVPlanType: getSchemeTypeIn,
            IVPeriod: value
        }).then((data) => {
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setchartData(DecryptAESdata(data.data))
                setloadingshow(false);
                // console.log(DecryptAESdata(data.data))
            }
        });
    }, [BaseURL, value]);

    const handleChange = () => {
        let path = window.location;
        navigate(path, { state: { plan: "performance" } });
    }

    useLayoutEffect(() => {
        am5.addLicense("AM5C420959785");
        var root = am5.Root.new("chartdiv");

        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        var chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: true,
            panY: true,
            wheelX: "panX",
            wheelY: "zoomX",
            pinchZoomX: true,
            // layout: root.verticalLayout
        }));

        var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
        cursor.lineY.set("visible", false);

        var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
        xRenderer.labels.template.setAll({
            // rotation: -40,
            centerY: am5.p100,
            centerX: am5.p50,
            fontSize: 10
        });

        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            categoryField: "country",
            renderer: xRenderer,
            tooltip: am5.Tooltip.new(root, {})
        }));

        var yRenderer = am5xy.AxisRendererY.new(root, {});
        yRenderer.labels.template.setAll({
            fontSize: 11
        });
        yRenderer.labels.template.set('visible', true)

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: yRenderer,
        }));

        yAxis.get("renderer").grid.template.setAll({
            strokeWidth: 0,
            visible: true,
        });

        xAxis.get("renderer").grid.template.setAll({
            location: 0,
            strokeWidth: 0,
            visible: true
        });

        var series = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: "Series 1",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "value",
            stroke: am5.color(0x2a4e96),
            categoryXField: "country",
            tooltip: am5.Tooltip.new(root, {
                labelText: "{valueY}% of instance in the range {country}"
            })
        }));


        series.set("fill", am5.color(0x2a4e96));

        function generateChartData() {
            let chartData = [];
            if (data != null && data != []) {
                for (var i = 0; i < data.length; i++) {
                    chartData.push({
                        country: "< 0%",
                        value: data[i].I0,
                    });
                    chartData.push({
                        country: "0 - 8%",
                        value: data[i].I0to8,
                    });
                    chartData.push({
                        country: "8 - 12%",
                        value: data[i].I08to12,
                    });
                    chartData.push({
                        country: "12 - 20%",
                        value: data[i].I12to20,
                    });
                    chartData.push({
                        country: "> 20%",
                        value: data[i].I20
                    });
                }
            }
            return chartData;
        }

        let datanew = generateChartData();

        series.columns.template.setAll({
            width: 25
        });

        xAxis.data.setAll(datanew);
        series.data.setAll(datanew);

        series.appear(1000);
        chart.appear(1000, 100);

        return (() => {
            root.dispose();
        })
    }, [data])

    return (
        <>
            <div className="gradiant-head-box">
                <div className="gradiant-head-container">
                    <h3 className="gradiant-head ">Rolling Returns
                    <span className="hover-fund info-img"><img src={info} alt="fund-info-img"></img>
                        <span className="hover-text-summary center">
                            {/* <p> */}
                            {/* Historical, annualized average returns, useful for examining the behaviour of returns for
                             a given holding period. For eg: Rolling returns for 5 years are calculated by checking
                              all 5 year time periods across a fund’s history and calculating average/ minimum/ maximum values.  */}
                            {/* </p> */}

                            Rolling returns give a sense of the returns generated for a certain holding period
                            irrespective of the day on which an investor invests in a particular fund.
                            In the calculation below, 1 year rolling returns are calculated over 3 year period,
                            3 year returns have been calculated for a 5 year period and 5 year returns have been calculated
                            on a daily basis for a 10 year period. The bars represent the % of instances where the fund has
                            provided returns within a certain return range. For greater details on calculation methodology,
                            please refer to rolling return calculations in the performance tab.
                        </span>

                    </span>
                    </h3>
                    
                    {data && <div className="form-group">
                        <div className="select-container">
                            <label
                                htmlFor="rolling-returns-period"
                                className="sr-only"
                                >
                                Select rolling returns period
                                </label>
                            <select name="fund" id="rolling-returns-period" className="data-selector" onChange={(event) => setValue(event.target.value)} autoComplete="off">
                                <option value="1year">1 Year</option>
                                <option value="3year">3 Years</option>
                                <option value="5year">5 Years</option>
                            </select>
                            <i className="fa fa-caret-down"></i>
                        </div>
                    </div>}
                </div>
                <div className="gradiant-content">
                    <div className="padding-box-inner" style={{position : "relative"}}>
                        {data && <p className="text-13 mb-2">Bars show distribution of returns in given range for
                            selected time period.</p>}
                        {/* {loadingshow ? <div className="textcentervertex">
                            <img src={animation} alt="Loading" />
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        } */}
                        {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
                        {loadingshow ? (
                        <div className="textcentervertex HomeLoader">
                          <img src={animation} alt="Loading" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        <div>
                            {(data === null) ? <h6 style={{
                                        textAlign : "center",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        position : "absolute",
                                        top : "45%"
                                    }}>This Scheme is a new scheme and hence does not have any performance track record.
                                    </h6> : ''}
                          
                          
                        <div className="img-container">
                            {data && <span className="rolling-Y-text"> % of Instances</span>}
                            <div id="chartdiv" className="chartmtt" style={{ width: "100%", height: "235px", marginTop: "-35px" }}></div>
                            {data &&<span className="rolling-X-text">Range of Returns </span>}
                        </div>
                      
                         
                       </div>
                     )}
                        {data &&<button className="rolling-side-performance" onClick={handleChange} aria-label="view performance details button">View Performance Details</button>}
                    </div>
                </div>

            </div>
        </>
    )
}

export default RollingReturns